import {AppComponent} from "../App";
import {storage} from "../utils/localstorage";
import bridge from "@vkontakte/vk-bridge";
import React, {createContext, useEffect, useState} from "react";
import {onAuthStateChanged} from "firebase/auth";
import {auth} from "../firebase";
import {Navigate} from "react-router-dom";
import {Restriction} from "../components/Restriction";
import {ShouldPay} from "../components/ShouldPay";
import {ShouldTrial} from "../components/ShouldTrial";
import {ShouldRenew} from "../components/ShouldRenew";
import {postPure} from "../utils/post";
import {log} from "../utils/log";

export const MiniAppContext = createContext({});

const Auth = ({children}) => {
    const [loaded, setLoaded] = useState(false);

    const addAuthData = (data) => {
        //if (storage("authData")) return;
        storage("authData", Object.fromEntries(Object.entries(data).filter(([_, value]) => value !== undefined)));
    }
    const telegram = async () => {
        const hash = Array.from(new URLSearchParams(decodeURIComponent(document.location.hash.replace("#tgWebAppData=", "")))).reduce((a, [k, v]) => ({
            ...a,
            [k]: v
        }), {});
        const webApp = await (() => new Promise(resolve => {
            const s = document.createElement("script");
            document.body.appendChild(s);
            s.onload = () => {
                const webApp = window.Telegram.WebApp;
                webApp.ready();
                webApp.expand();
                webApp.disableVerticalSwipes();
                webApp.setHeaderColor('#ffffff');
                resolve(webApp)
            };
            s.src = "https://telegram.org/js/telegram-web-app.js";
        }))();

        try {
            hash.user = JSON.parse(hash.user);
        } catch (e) {
            hash.user = {}
        }

        try {
            hash.param = JSON.parse(decodeURIComponent(atob(hash.start_param)));
        } catch (e) {
            hash.param = {}
        }

        const {token} = await postPure({
            method: "token/tg",
            mos: new Date().getTimezoneOffset(),
            userId: "tg-" + hash.user.id,
            initData: webApp.initData
        });

        addAuthData({
            appType: "tg",
            token,
            date: hash.auth_date && new Date(hash.auth_date * 1000),
            instance: hash.chat_instance,
            param: hash.param,
            platform: `Telegram ${hash.tgWebAppPlatform}`,
            version: hash.tgWebAppVersion,
            id: "tg-" + hash.user.id,
            firstname: hash.user.first_name,
            lastname: hash.user.last_name,
            username: hash.user.username,
            photo: hash.user.photo_url,
            lang: hash.user.language_code,
            displayName: hash.user.first_name || hash.user.last_name || hash.user.username
        })

    }
    const vk = async () => {

        log({
            event: "vkBridge",
            isEmbedded: bridge.isEmbedded(),
            isIframe: bridge.isIframe(),
            isStandalone: bridge.isStandalone(),
            isWebView: bridge.isWebView(),
        })


        await bridge.send('VKWebAppInit');
        const launchParams = await bridge.send('VKWebAppGetLaunchParams');
        const user = await bridge.send('VKWebAppGetUserInfo');
        const {platform, version} = await bridge.send('VKWebAppGetClientVersion');

        //await bridge.send('VKWebAppTrackEvent', {event_name: 'login'})

        const startParam = window.location.hash.substring(1);
        const leadId = startParam ? JSON.parse(decodeURIComponent(atob(startParam))) : "";

        const {token} = await postPure({
            method: "token/vk",
            mos: new Date().getTimezoneOffset(),
            userId: "vk-" + user.id,
            url: document.location.href
        });

        addAuthData({
            appType: "vk",
            displayName: user.first_name || user.last_name,
            id: "vk-" + user.id.toString(),
            token,
            photo: user.photo_100,
            firstname: user.first_name,
            lastname: user.last_name,
            lang: launchParams.vk_language,
            platform: `VK ${launchParams.vk_platform}`,
            param: leadId,
            username: user.first_name + " " + user.last_name,
            version: `${platform}-${version}`,
        })
    }
    const google = () => {
        return new Promise(resolve => {
            const unsubscribe = onAuthStateChanged(auth, async user => {
                if (user) {

                    const {token} = await postPure({
                        method: "token/gg",
                        mos: new Date().getTimezoneOffset(),
                        userId: "gg-" + user.email
                    });

                    addAuthData({
                        appType: "gg",
                        token,
                        displayName: user.displayName,
                        username: user.displayName,
                        id: "gg-" + user.email,
                        photo: user.photoURL,

                        param: {},
                        firstname: "",
                        lastname: "",
                        lang: "",
                        platform: "",
                        version: "",
                    });
                }
                resolve();
                unsubscribe();
            });
        })
    }

    const isTelegram = document.location.href.includes("tgWebAppData");
    const isVk = document.location.href.includes("vk_user_id");
    const isGoogle = document.location.href.includes("/app") && !isTelegram && !isVk && !storage("authData");

    useEffect(() => {
        (async () => {
            AppComponent.SetLoading(true);

            try {
                if (isTelegram) await telegram();
                if (isVk) await vk();
                if (isGoogle) await google();
            } catch (e) {
                log({event: "error Auth useEffect[]"})
            }


            AppComponent.SetLoading(false);
            setLoaded(true);
        })()
    }, [])

    if (!loaded) return false;
    if (!storage("authData")) return <Navigate to={"/"}/>;

    return children
}

export const MiniApp = ({children}) => {
    const [started, setStarted] = useState(false);
    const [restriction, setRestriction] = useState(null);
    const [locked, setLocked] = useState(false);

    AppComponent.setRestriction = (data) => setRestriction(data);
    AppComponent.ShouldPay = () => setRestriction(<ShouldPay/>);
    AppComponent.ShouldTrial = (items) => setRestriction(<ShouldTrial items={items}/>);
    AppComponent.ShouldRenew = () => setRestriction(<ShouldRenew/>);
    AppComponent.Forbidden = () => setRestriction(<Navigate to="/"/>);
    AppComponent.Locked = (data) => setLocked(data);
    AppComponent.Started = () => setStarted(true);

    if (restriction) return <Restriction restriction={restriction}/>

    return (
        <MiniAppContext.Provider value={{started, locked}}>
            <Auth>
                {children}
            </Auth>
        </MiniAppContext.Provider>
    );
}
